import { render, staticRenderFns } from "./processRecord.vue?vue&type=template&id=5db31820&scoped=true&"
import script from "./processRecord.vue?vue&type=script&lang=js&"
export * from "./processRecord.vue?vue&type=script&lang=js&"
import style0 from "./processRecord.vue?vue&type=style&index=0&id=5db31820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db31820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db31820')) {
      api.createRecord('5db31820', component.options)
    } else {
      api.reload('5db31820', component.options)
    }
    module.hot.accept("./processRecord.vue?vue&type=template&id=5db31820&scoped=true&", function () {
      api.rerender('5db31820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/process/processRecord.vue"
export default component.exports